function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import uuidv1 from 'uuid/v1';
var FilterTypes = {
  EQUAL: 'eq',
  NOT_EQUAL: 'neq'
};
var Filter = /*#__PURE__*/function () {
  function Filter(property, value, operator, label, preSelected) {
    _classCallCheck(this, Filter);
    this.id = uuidv1();
    this.property = property;
    this.value = value;
    this.operator = operator === FilterTypes.NOT_EQUAL ? FilterTypes.NOT_EQUAL : FilterTypes.EQUAL;
    this.label = label;
    this.preSelected = preSelected;
  }
  return _createClass(Filter, [{
    key: "compare",
    value: function compare(location) {
      if (this.operator === FilterTypes.EQUAL) {
        return location[this.property] === this.value;
      }
      return location[this.property] !== this.value;
    }
  }], [{
    key: "fromSettings",
    value: function fromSettings(data) {
      var filterState = [];
      data.forEach(function (filter) {
        filterState[filter.id] = filter.preSelected;
      });
      return filterState;
    }
  }]);
}();
var LocationFilterManager = /*#__PURE__*/function () {
  function LocationFilterManager() {
    _classCallCheck(this, LocationFilterManager);
    /**
     *
     * @type {Filter[]}
     */
    this.filters = [];
  }

  /**
   * @param {Filter} filter
   */
  return _createClass(LocationFilterManager, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this.filters.push(filter);
    }

    /**
     * @param {Filter} filter
     */
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      this.filters.splice(this.filters.findIndex(function (x) {
        return x.id === filter.id;
      }), 1);
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.filters = [];
    }

    /**
     * @param {Location} location
     */
  }, {
    key: "compare",
    value: function compare(location) {
      var isValid = true;
      this.filters.forEach(function (filter) {
        if (!filter.compare(location)) {
          isValid = false;
        }
      });
      return isValid;
    }
  }]);
}();
export { LocationFilterManager, Filter, FilterTypes };